<template>
  <div>
    <Table :no-data-text="$t('common.noData')" :columns="columns" :loading="modalLoading" :data="queryDatabaseByGroupIdList" :height="500">
    </Table>
  </div>
</template>
<script>
    var tableDatabase = {}
    export default {
        name: 'TableDatabase',
        data() {
            return {
                Name: '',
                modalLoading: false,
                columns: [
                    {
                        title: '名称',
                        key: 'name'
                    },
                    {
                        title: '数据库ID',
                        key: 'databaseId'
                    },
                    {
                        title: 'DB引擎',
                        key: 'engine'
                    },
                    {
                        title: '实例类型',
                        key: 'type'
                    },
                    {
                        title: '区域',
                        key: 'region'
                    }
                ],
              queryDatabaseByGroupIdList: []
            }
        },
        beforeCreate: function () {
          tableDatabase = this
        },
        mounted: function () {
          tableDatabase.queryInstancesByGroupId()
        },
        methods: {
          queryInstancesByGroupId: function () {
            this.modalLoading=true;
            tableDatabase.$api.alertRule.selectInstantiationByAlertRule('id', this.$route.query.id)
              .then(res => {
                this.queryDatabaseByGroupIdList = res.data[0].databaseList;
                this.modalLoading = false
              }).catch(res => {
              // 如果列表里没数据 返回
              this.queryDatabaseByGroupIdList = undefined
            })
          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/rule_engine/TableDatabase.vue